module.exports = __webpack_public_path__ + "img/cloud-showers.b53cd34d.svg";